import React, { useEffect, useState } from 'react';
import apiClient from '../../../Api/apiClient';
import { useNavigate } from 'react-router-dom';
import { FaFileInvoice, FaEye } from 'react-icons/fa';

const BillStatus = () => {
  const [billData, setBillData] = useState([]);
  const [error, setError] = useState(null);
  const userType = localStorage.getItem('user_type');
  console.log('usertype in publish tender form:', userType);

  useEffect(() => {
    const fetchBillData = async () => {
      try {
        const apiEndpoint =
          userType === 'end_user'
            ? '/user/tender-end-user/bill-status'
            : userType === 'user'
            ? '/user/tender-user/bill-status'
            : '';

        const response = await apiClient.get(
          // '/user/tender-end-user/bill-status'
          // '/user/tender-user/bill-status'
          apiEndpoint
        );
        console.log(response.data.data);
        setBillData(response.data.data);
      } catch (error) {
        setError('Failed to fetch bill data. Please try again later.');
        console.error(error);
      }
    };

    fetchBillData();
  }, []);

  const navigate = useNavigate();

  const handleInvoiceView = id => {
    navigate(`/invoice-details/${id}`);
  };

  const handleView = id => {
    navigate(`/subscriber-details/${id}`);
  };

  return (
    <div className="mt-40">
      <div className="container mx-auto md:p-4 p-2 h-auto bg-BrowsBg rounded-md">
        <h2 className="text-xl font-bold mb-4">Bill Status</h2>
        {error ? (
          <p className="text-red-500 text-center">{error}</p>
        ) : (
          <div className="overflow-x-auto md:text-sm text-xs text-center">
            <div className="min-w-max h-[220px] md:h-[400px] 2xl:h-[660px] overflow-y-auto bg-white border rounded-lg shadow">
              {/* Table Header */}
              <div className="grid grid-cols-6 md:gap-4 gap-1 md:p-4 p-2 px-1 bg-billStatusHeaderBg font-semibold text-white sticky top-0 z-10">
                <div>Serial No</div>
                <div>Package Name</div>
                <div>Pay Amount</div>
                <div>Payment Status</div>
                <div>View Details</div>
                <div>View Invoice</div>
              </div>

              {/* Table Rows */}
              <div className="divide-y text-center">
                {billData.map((bill, index) => (
                  <div
                    key={bill.id}
                    className="grid grid-cols-6 md:gap-4 gap-1 p-6 hover:bg-gray-100"
                  >
                    <div>{index + 1}</div>
                    <div>{bill.package_name}</div>
                    <div>{bill.pay_amount}</div>
                    <div>{bill.payment_status}</div>
                    {/* <div className="flex gap-2 items-center justify-center"> */}
                    {/* Eye Button */}
                    <div className="relative group ">
                      <button onClick={() => handleView(bill.id)}>
                        <FaEye className="text-lg" />
                      </button>
                      {/* <div className="absolute bottom-full mb-0 hidden group-hover:block bg-black text-white md:text-xs text-[8px] rounded px-1 py-1 md:w-28 w-16">
                        View Details
                      </div> */}
                    </div>
                    {/* Invoice Button */}
                    <div className="relative group ">
                      <button
                        onClick={() => handleInvoiceView(bill.sp_order_id)}
                      >
                        <FaFileInvoice className="text-md" />
                      </button>
                      {/* <div className="absolute bottom-full mb-0 hidden group-hover:block bg-black text-white md:text-xs text-[8px] rounded px-1 py-1 md:w-28 w-16">
                        View Invoice
                      </div> */}
                    </div>
                    {/* </div> */}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BillStatus;
